let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("bUqpo")).then(() => parcelRequire('4Speu'));